import { Injectable } from '@angular/core';
import { IEnvironment } from './environment.interface';
import { environment } from './environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService implements IEnvironment {
  get production() {
    return environment.production;
  }

  get enableDebugTools() {
    return environment.enableDebugTools;
  }

  get logLevel() {
    return environment.logLevel;
  }

  get apiUrl() {
    return environment.apiUrl;
  }

  get awsCognito() {
    return environment.awsCognito;
  }
}
